/* ml-pdp2.js — comportamento da PDP MyLivia v2.
   Vanilla, sem dependencia do JS do Warehouse. Tudo delegado por data-attribute
   para sobreviver a reordenacao de secoes no editor de tema. */
(function () {
  'use strict';

  /* ---------- Galeria ---------- */
  function initGaleria(raiz) {
    var slides = raiz.querySelector('[data-mlp-slides]');
    if (!slides) return;
    var total = slides.children.length;
    if (!total) return;
    var atual = 0;
    var dots = raiz.querySelectorAll('[data-mlp-dot]');
    var thumbs = raiz.querySelectorAll('[data-mlp-thumb]');

    function ir(i) {
      atual = (i + total) % total;
      slides.style.transform = 'translateX(' + (-100 * atual) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === atual); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === atual); });
    }

    raiz.querySelectorAll('[data-mlp-prev]').forEach(function (b) {
      b.addEventListener('click', function () { ir(atual - 1); });
    });
    raiz.querySelectorAll('[data-mlp-next]').forEach(function (b) {
      b.addEventListener('click', function () { ir(atual + 1); });
    });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { ir(k); }); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { ir(k); }); });

    /* arrasto lateral no toque */
    var x0 = null;
    slides.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    slides.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) ir(atual + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });

    ir(0);
  }

  /* ---------- Stepper de quantidade ---------- */
  function initQty(raiz) {
    var campo = raiz.querySelector('[data-mlp-qty-input]');
    if (!campo) return;
    function ajusta(delta) {
      var v = parseInt(campo.value, 10);
      if (isNaN(v)) v = 1;
      campo.value = Math.max(1, v + delta);
      campo.dispatchEvent(new Event('change', { bubbles: true }));
    }
    var menos = raiz.querySelector('[data-mlp-qty-minus]');
    var mais = raiz.querySelector('[data-mlp-qty-plus]');
    if (menos) menos.addEventListener('click', function () { ajusta(-1); });
    if (mais) mais.addEventListener('click', function () { ajusta(1); });
  }

  /* ---------- Seletor de variante ---------- */
  function initVariantes(raiz) {
    var botoes = raiz.querySelectorAll('[data-mlp-variant]');
    if (!botoes.length) return;
    var campoId = raiz.querySelector('[data-mlp-variant-id]');
    var precoEl = raiz.querySelector('[data-mlp-price]');
    var nomeEl = raiz.querySelector('[data-mlp-variant-name]');

    botoes.forEach(function (b) {
      b.addEventListener('click', function () {
        botoes.forEach(function (o) {
          o.classList.remove('is-active');
          o.setAttribute('aria-checked', 'false');
        });
        b.classList.add('is-active');
        b.setAttribute('aria-checked', 'true');
        if (campoId) campoId.value = b.getAttribute('data-mlp-variant');
        if (precoEl && b.getAttribute('data-mlp-variant-price')) {
          precoEl.textContent = b.getAttribute('data-mlp-variant-price');
        }
        if (nomeEl) nomeEl.textContent = b.getAttribute('data-mlp-variant-name') || '';
        /* mantem a URL coerente com a variante escolhida */
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', b.getAttribute('data-mlp-variant'));
          window.history.replaceState({}, '', u);
        } catch (e) { /* navegador antigo: ignora */ }
      });
    });
  }

  /* ---------- Acordeao ---------- */
  function initAcordeao(escopo) {
    escopo.querySelectorAll('[data-mlp-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var alvo = document.getElementById(btn.getAttribute('aria-controls'));
        var aberto = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', aberto ? 'false' : 'true');
        if (alvo) alvo.hidden = aberto;
      });
    });
  }

  /* ---------- Barra fixa ---------- */
  function initSticky() {
    var barra = document.querySelector('[data-mlp-sticky]');
    var gatilho = document.querySelector('[data-mlp-sticky-anchor]');
    if (!barra || !gatilho || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        barra.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    obs.observe(gatilho);
  }

  function iniciar() {
    document.querySelectorAll('[data-mlp-gallery]').forEach(initGaleria);
    document.querySelectorAll('[data-mlp-buybox]').forEach(function (r) {
      initQty(r);
      initVariantes(r);
    });
    initAcordeao(document);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* editor de tema: reinicializa quando uma secao e recarregada */
  document.addEventListener('shopify:section:load', iniciar);
})();
